const AUTHTOKEN_LOGOUT = "AUTHTOKEN_LOGOUT";
const RACKSPACES_REQUEST = "RACKSPACES_REQUEST";
const RACKSPACES_ERROR = "RACKSPACES_ERROR";
const RACKSPACES_SUCCESS = "RACKSPACES_SUCCESS";
const RACKSPACES_CREATE_REQUEST = "RACKSPACES_CREATE_REQUEST"
const RACKSPACES_CREATE_SUCCESS = "RACKSPACES_CREATE_SUCCESS"
const RACKSPACES_CREATE_ERROR = "RACKSPACES_CREATE_ERROR"
const RACKSPACES_UPDATE_REQUEST = "RACKSPACES_UPDATE_REQUEST";
const RACKSPACES_UPDATE_SUCCESS = "RACKSPACES_UPDATE_SUCCESS";
const RACKSPACES_UPDATE_ERROR = "RACKSPACES_UPDATE_ERROR"
const CROSSCONNECTS_REQUEST = "CROSSCONNECTS_REQUEST";
const CROSSCONNECTS_ERROR = "CROSSCONNECTS_ERROR";
const CROSSCONNECTS_SUCCESS = "CROSSCONNECTS_SUCCESS";
const CROSSCONNECT_UPDATE_REQUEST = 'CROSSCONNECT_UPDATE_REQUEST'
const CROSSCONNECT_UPDATE_SUCCESS = 'CROSSCONNECT_UPDATE_SUCCESS'
const CROSSCONNECT_UPDATE_ERROR = 'CROSSCONNECT_UPDATE_ERROR'
const CROSSCONNECT_CREATE_REQUEST = 'CROSSCONNECT_CREATE_REQUEST'
const CROSSCONNECT_CREATE_SUCCESS = 'CROSSCONNECT_CREATE_SUCCESS'
const CROSSCONNECT_CREATE_ERROR = 'CROSSCONNECT_CREATE_ERROR'

import Vue from "vue";

const state = {rackspacesstatus: "", rackspaces: null, crossconnectsstatus: "", crossconnects: null};

const getters = {
    getRackspacesStatus: state => state.rackspacesstatus,
    getRackspaces: state => {
        return (state.rackspaces ? state.rackspaces : [])
    },
    getRackspace: (state) => (rackspaceUUID) => {
        return state.rackspaces.find(rackspace => rackspace.uuid === rackspaceUUID)
    },
    getRackspacesLoaded: state => !!state.rackspaces,
    getRackspaceSelection: state => {
        //Populate Rack selection Select and Multiselect lists
        if (state.rackspaces == null) {
            return [];
        }
        let getRacks = state.rackspaces;
        let rackList = [];

        for (let i = 0; i < getRacks.length; i++) {
            if (Object.keys(getRacks[i]).includes('enddate') && getRacks[i].enddate !== null) {
                //Skips inactive Racks
                continue;
            }
            let thisRack = { rackspaceid: '', description: '', siteid: '' };
            thisRack.rackspaceid = getRacks[i].rackspaceid
            thisRack.description = getRacks[i].description
            thisRack.title = getRacks[i].rackspaceid + ' - ' + getRacks[i].description
            thisRack.siteid = getRacks[i].siteid
            thisRack.uuid = getRacks[i].uuid
            rackList.push(thisRack);
        }
        return rackList;
    },
    getRackspaceCrossconnects: (state) => (rackspaceID) => {
        if(!rackspaceID){
            return state.crossconnects
        }

        return (state.crossconnects === null ? [] :state.crossconnects.filter(crossconnect => {
            return crossconnect.aendrackspaceid === rackspaceID || crossconnect.bendrackspaceid === rackspaceID
        }))
    },
    getCrossconnectsStatus: state => state.crossconnectsstatus,
    getCrossconnects: state => {
        return (state.crossconnects === null ? [] : state.crossconnects)
    },
    getCrossconnectsLoaded: state => !!state.crossconnects,
    getCrossconnect: (state) => (crossconnectUUID) => {
        return (state.crossconnects === null ? [] : state.crossconnects.find(crossconnect => crossconnect.uuid === crossconnectUUID))
    },
};

const actions = {
    [RACKSPACES_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(RACKSPACES_REQUEST);
            commit('addLoading', {handle:'rackspaces',name:'Load Rackspaces'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'rackspaces', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'rackspaces')
                        if (resp.result === 'Success') {
                            commit(RACKSPACES_SUCCESS, resp.payload)
                            resolve(resp)
                        } else {
                            commit(RACKSPACES_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'rackspaces')
                    commit(RACKSPACES_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [RACKSPACES_CREATE_REQUEST]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(RACKSPACES_CREATE_REQUEST);
            commit('addLoading', {handle: 'rackcreate'+payload.rackspaceid, name: 'Creating Rackspace '+payload.rackspaceid})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'rackspace', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'rackcreate'+payload.rackspaceid)
                        if (resp.result === 'Success') {
                            commit(RACKSPACES_CREATE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(RACKSPACES_CREATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'rackcreate'+payload.rackspaceid)
                    commit(RACKSPACES_CREATE_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [RACKSPACES_UPDATE_REQUEST]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(RACKSPACES_UPDATE_REQUEST);
            commit('addLoading', {handle: 'rackupdate'+payload.originalRackID, name: 'Update Rackspace '+payload.originalRackID})


            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'rackspace/'+payload.originalRackID, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'rackupdate'+payload.originalRackID)
                        if (resp.result === 'Success') {
                            commit(RACKSPACES_UPDATE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(RACKSPACES_UPDATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'rackupdate'+payload.originalRackID)
                    commit(RACKSPACES_UPDATE_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [CROSSCONNECTS_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(CROSSCONNECTS_REQUEST);
            commit('addLoading', {handle:'crossconnects',name:'Load Cross-Connects'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'crossconnects', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'crossconnects')
                        if (resp.result === 'Success') {
                            commit(CROSSCONNECTS_SUCCESS, resp.payload)
                            resolve(resp)
                        } else {
                            commit(CROSSCONNECTS_ERROR);
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'crossconnects')
                    commit(CROSSCONNECTS_ERROR);
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [CROSSCONNECT_CREATE_REQUEST]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(CROSSCONNECT_CREATE_REQUEST);
            commit('addLoading', {handle: 'crossconnectcreate'+payload.crossconnectid, name: 'Creating Cross-Connect '+payload.crossconnectid})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'crossconnect', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'crossconnects')
                        if (resp.result === 'Success') {
                            commit(CROSSCONNECT_CREATE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(CROSSCONNECT_CREATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'crossconnects')
                    commit(CROSSCONNECT_CREATE_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [CROSSCONNECT_UPDATE_REQUEST]: ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit(CROSSCONNECT_UPDATE_REQUEST);
            commit('addLoading', {handle: 'crossconnectupdate'+payload.crossconnectid, name: 'Updating Cross-Connect '+payload.crossconnectid})

            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };

            fetch(Vue.prototype.$apiServer + 'crossconnect/'+payload.crossconnectid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'crossconnectupdate'+payload.crossconnectid)
                        if (resp.result === 'Success') {
                            commit(CROSSCONNECT_UPDATE_SUCCESS)
                            resolve(resp)
                        } else {
                            commit(CROSSCONNECT_UPDATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit('removeLoading', 'crossconnectupdate'+payload.crossconnectid)
                    commit(CROSSCONNECT_UPDATE_ERROR)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
};

const mutations = {
    [RACKSPACES_REQUEST]: state => {
        state.rackspacesstatus = "loading";
    },
    [RACKSPACES_SUCCESS]: (state, resp) => {
        state.rackspacesstatus = "success";
        Vue.set(state, "rackspaces", resp);
    },
    [RACKSPACES_ERROR]: state => {
        state.rackspacesstatus = "error";
    },
    [RACKSPACES_CREATE_REQUEST]: () => {
        state.rackspacesstatus = "loading";
    },
    [RACKSPACES_CREATE_SUCCESS]: () => {
        state.rackspacesstatus = "success";
    },
    [RACKSPACES_CREATE_ERROR]: () => {
        state.rackspacesstatus = "error";
    },
    [RACKSPACES_UPDATE_REQUEST]: () => {
        state.updatestatus = "loading";
    },
    [RACKSPACES_UPDATE_SUCCESS]: () => {
        state.updatestatus = "success";
    },
    [RACKSPACES_UPDATE_ERROR]: () => {
        state.updatestatus = "error";
    },
    [CROSSCONNECTS_REQUEST]: state => {
        state.crossconnectsstatus = "loading";
    },
    [CROSSCONNECTS_SUCCESS]: (state, resp) => {
        state.crossconnectsstatus = "success";
        Vue.set(state, "crossconnects", resp);
    },
    [CROSSCONNECTS_ERROR]: state => {
        state.crossconnectsstatus = "error";
    },
    [CROSSCONNECT_UPDATE_REQUEST]: state => {
        state.crossconnectsstatus = "loading";
    },
    [CROSSCONNECT_UPDATE_SUCCESS]: (state) => {
        state.crossconnectsstatus = "success";
    },
    [CROSSCONNECT_UPDATE_ERROR]: state => {
        state.crossconnectsstatus = "error";
    },
    [CROSSCONNECT_CREATE_REQUEST]: state => {
        state.crossconnectsstatus = "loading";
    },
    [CROSSCONNECT_CREATE_SUCCESS]: (state) => {
        state.crossconnectsstatus = "success";
    },
    [CROSSCONNECT_CREATE_ERROR]: state => {
        state.crossconnectsstatus = "error";
    },
    [AUTHTOKEN_LOGOUT]: state => {
        state.rackspaces = [];
        state.crossconnects = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};